module.exports = __webpack_public_path__ + "img/portfolio-3.10dd9eb8.jpg";